import { render, staticRenderFns } from "./tooltips.vue?vue&type=template&id=2ccdd614"
import script from "./tooltips.vue?vue&type=script&lang=js"
export * from "./tooltips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports